import { calcSecondsLeft, timersRegistry } from '@betgames/bg-tools';
import { GameId } from '@bg-shared/enums/GameId';
import { GameState } from '@bg-shared/enums/GameState';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { GAME_STATE_CHANNEL_PREFIX } from '@bg-shared/constants/socketChannels';
import { webAPIIntegration } from '@bg-shared/integrations/WebIntegration/webAPIIntegration';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { IBGIWebIntegration } from '@bg-shared/integrations/WebIntegration/interfaces';
import { isGameActive } from '@bg-shared/utils/isGameActive';
import { gamesStatusEntity } from './GamesStatus.entity';
import { IGameTimerOptions } from './interfaces';

export default class GamesStatusService {
    public configureTimer(options: IGameTimerOptions): void {
        const seconds = calcSecondsLeft(options.seconds, options.timestamp * 1000);
        const offsetSeconds = options.offsetSeconds || 0;
        const calculatedSecondsLeft = Math.max(0, seconds - offsetSeconds);

        timersRegistry.create({
            seconds,
            offsetSeconds,
            id: options.gameId,
            onFinish: () => {
                gamesStatusEntity.setOpenForBets(options.gameId, false);

                if (options.onFinish) {
                    options.onFinish();
                }
            },
            onFinishWithOffset: () => {
                gamesStatusEntity.setStarted(options.gameId, true);

                if (options.onFinishWithOffset) {
                    options.onFinishWithOffset();
                }

                if (isGameActive(options.gameId)) {
                    webAPIIntegration<IBGIWebIntegration>(
                        partnerSettingsStore.webIntegrationType,
                        (api) => {
                            api.runStarted();
                        },
                    );
                }
            },
        });

        if (calculatedSecondsLeft > 0) {
            gamesStatusEntity.setOpenForBets(options.gameId, true);
        } else {
            gamesStatusEntity.setStarted(options.gameId, true);
        }
    }

    public updateTimer(options: IGameTimerOptions): void {
        const seconds = calcSecondsLeft(options.seconds, options.timestamp * 1000);

        timersRegistry.get(options.gameId).update(seconds);

        gamesStatusEntity.setOpenForBets(options.gameId, !!seconds);
        gamesStatusEntity.setStarted(options.gameId, !seconds);
    }

    public stopGame(gameId: GameId): void {
        gamesStatusEntity.setStarted(gameId, false);
    }

    public startGame(gameId: GameId): void {
        timersRegistry.get(gameId).stop();
    }

    public configureStates(
        states: Array<{ gameId: GameId; state: GameState; delay: number }>,
    ): void {
        states.forEach((game) => {
            gamesStatusEntity.setState(game.gameId, game.state);

            webSocketsRepository.on<GameState>(
                `${GAME_STATE_CHANNEL_PREFIX}${game.gameId}`,
                (newState) => {
                    setTimeout(() => {
                        gamesStatusEntity.setState(game.gameId, newState);
                    }, game.delay);
                },
            );
        });
    }
}

export const gamesStatusService = new GamesStatusService();
